import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from 'ui';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { setOpenFilterId } from '../../worklist/containers/worklist-actions';

const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  font-weight: 300;
`;

const Name = styled.div`
  left: 0;
`;

const Icons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 5px;
  position: absolute;
  right: 0;
  background-color: #F8F8F8;
  padding-left: 5px;
`;

const SortIcon = styled.div`
  display: flex;
  flex-flow: row nowrap;
  cursor: pointer;
  align-items: center;
  i {
    cursor: pointer;
    color: black;
  }
`;

const MenuIcon = styled.div`
  cursor: pointer;
  i {
    cursor: pointer;
    color: black;
  }
`;

const FilterIcon = styled.div`
  i {
    color: black;
  }
`;

const getSortIcon = (icon) => {
  const iconClass = icon.replace('<i class="', '').replace('"></i>', '');
  return <Icon className={iconClass} />;
};

const CustomDetailHeader = ({
  column,
  enableSorting,
  setSort,
  showColumnMenu,
  displayName,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [sortDirection, setSortDirection] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { activeFilters, openFilterId } = useSelector(state => state.worklist);
  const refButton = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (showMenu && openFilterId !== column.colDef.filterId) {
      setShowMenu(false);
      setMenuOpen(false);
    }
  }, [openFilterId]);

  const onSortChanged = () => {
    if (enableSorting) {
      const sort = column.getSort();
      if (sort === 'asc') {
        setSort('desc');
        setSortDirection('desc');
      } else if (sort === 'desc') {
        setSort(null);
        setSortDirection(null);
      } else {
        setSort('asc');
        setSortDirection('asc');
      }
    }
  };

  const renderSortIcon = () => {
    const { icons } = column.colDef;
    if (!sortDirection) {
      return null;
    }
    return <SortIcon>
      {getSortIcon(sortDirection === 'asc' ? icons.sortAscending : icons.sortDescending)}
    </SortIcon>;
  };

  const renderMenuIcon = () => {
    if (column?.colDef?.filterId && showMenu) {
      return <MenuIcon
        ref={refButton}
        onClick={(e) => {
          e.stopPropagation();
          setMenuOpen(s => !s);
          dispatch(setOpenFilterId(column.colDef.filterId));
          showColumnMenu(refButton.current);
        }}
      >
        <Icon className='fa-light fa-bars' />
      </MenuIcon>;
    }
    return null;
  };

  const renderFilterIcon = () => {
    if (Object.keys(activeFilters || {})?.find(k => k === column.colDef.filterId)) {
      return <FilterIcon><Icon className='fa-regular fa-filter' /></FilterIcon>;
    }
    return null;
  };

  return (
    <Header
      onClick={onSortChanged}
      onMouseOver={() => setShowMenu(true)}
      onMouseLeave={() => !menuOpen && setShowMenu(false)}
    >
      <Name>{displayName}</Name>
      <Icons>
        {renderSortIcon()}
        {renderFilterIcon()}
        {renderMenuIcon()}
      </Icons>
    </Header >
  );
};

CustomDetailHeader.propTypes = {
  column: PropTypes.object,
  enableSorting: PropTypes.bool,
  setSort: PropTypes.func,
  showColumnMenu: PropTypes.func,
  displayName: PropTypes.string,
};

export default CustomDetailHeader;
